// projects/humanresources-common-shared/assets/i18n/*/hr-bpmn.json
export class HrBpmn {
    private static readonly keyPrefix = 'hrBpmn';
    public static processNotFinished = `${HrBpmn.keyPrefix}.processNotFinished`;
    public static sendApprove = `${HrBpmn.keyPrefix}.sendApprove`;
    public static sendDraft = `${HrBpmn.keyPrefix}.sendDraft`;
    public static approve = `${HrBpmn.keyPrefix}.approve`;
    public static operations = `${HrBpmn.keyPrefix}.operations`;
    public static bpmnChangeRequestMessage = `${HrBpmn.keyPrefix}.bpmnChangeRequestMessage`;
    public static canNotChangeNonDraft = `${HrBpmn.keyPrefix}.canNotChangeNonDraft`;
}
